import * as moment from "moment"
import { ModelAssumptionsUtil } from "src/app/core/v2/state/valuation-process/core/income/model-assumptions-util"
import { CostAssessmentRecordRow, DepreciatedRecordRow } from "../../types"
import { RecordOptions } from "./calculation"
import { normalizeRecords } from "./normalize"
import { recordsHasNullDepreciatedCost, totalCostOfRecords, totalDepreciatedCostOfRecords } from "./utils"

export interface WeibullCDFOptions {
  kind: 'weibull-cdf',
  economicLife: number,
  weibullShape: number
}
interface WeibullCDFParameters {
  economicLife: number,
  shape: number
}
export function weibullCDFMethod(
  records: CostAssessmentRecordRow[],
  recordOptions: RecordOptions,
  options: WeibullCDFOptions
) {
  const { valuationDate, buildingConstructionDate, size } = recordOptions
  const { economicLife, weibullShape } = options
  const parameters: WeibullCDFParameters = {
    economicLife,
    shape: weibullShape
  }

  const _records = normalizeRecords(records, recordOptions)
  const _valuationDate = moment(valuationDate)
  const _constructionDate = moment(buildingConstructionDate)
  const yearDiff = ModelAssumptionsUtil._yearsDiff(_valuationDate, _constructionDate)
  const mappedRecords: DepreciatedRecordRow[] = _records.map(item => {
    const depreciatedCost = _depreciatedValue(
      item.total_cost,
      yearDiff,
      parameters
    )
    return {
      ...item,
      depreciated_cost: depreciatedCost,
      depreciated_per_unit: size && size !== 0 ? depreciatedCost / size : 0
    }
  })
  if (recordsHasNullDepreciatedCost(mappedRecords)) return null
  const totalCost = totalCostOfRecords(mappedRecords)
  const totalDepreciatedCost = totalDepreciatedCostOfRecords(mappedRecords)
  return {
    records: mappedRecords,
    graphValues: _graphValues(economicLife, totalCost, parameters),
    totalCost,
    totalDepreciatedCost,
    yearDiff
  }
}
export function weibullCDF() {}

function _depreciatedValue(
  totalCost: number,
  years: number,
  parameters: WeibullCDFParameters
) {
  const { economicLife, shape } = parameters
  if (
    economicLife === undefined ||
    economicLife === null ||
    economicLife === 0
  ) return null
  return totalCost - (totalCost * (1 - Math.exp(Math.pow(-(years / economicLife), shape))))
}

function _graphValues(
  economicLife: number,
  totalCost: number,
  parameters: WeibullCDFParameters
) {
  const values: {
    age: number,
    depreciatedValue: number,
    reducingBalancePerYear: number
  }[] = []
  for (let i = 0; i <= economicLife; i++) {
    const depreciatedValue = _depreciatedValue(totalCost, i , parameters)
    const reducingBalancePerYear = i == 0
      ? totalCost - depreciatedValue
      : values[i - 1].depreciatedValue - depreciatedValue
    values.push({
      age: i,
      depreciatedValue,
      reducingBalancePerYear
    })
  }
  return values
}